import Component from './warning-hint';

export default Component;
